export enum UserRoleEnum {
  ALL = 'all',
  SUPER_ADMIN = 'superAdmin',
  ADMIN = 'admin',
  PRO_ADMIN = 'proAdmin',
  PRO_ADMIN_QC = 'proAdminQC',
  PRO_RATER = 'ProRater',
  PRO_INTERVIEW = 'proInterviewer',
  PRO_MODERATOR = 'proModerator',
  STUDENT = 'student',
  LEARNER = 'learnerStudent',
  LEARNING_ADMIN = 'learnerAdmin',
  USER = 'User',
  SCHOOL_ADMIN = 'schoolAdmin',
  FACILITATOR_ADMIN = 'facilitatorAdmin',
  FACILITATOR = 'facilitator',
  EXAMINER = 'Examiner',
  STANDARDIZED_CLIENT = 'Standardized Client',
  // ─── PRO Screener Queue & QC Workflow roles ──────────────────
  // Rôles pour la file d'attente des examinateurs et le flux d'AQ
  PRO_SCREENER = 'proScreener', // Phase 1 / Phase 2 screener / Examinateur Phase 1 / Phase 2
  PRO_QC_REVIEWER = 'proQcReviewer', // QC reviewer / Réviseur AQ
  PRO_CD_REVIEWER = 'proCdReviewer', // Clinical Director / Directeur clinique
  // Manager — superset of proAdmin/proAdminQC with EXCLUSIVE preliminary
  // sign-off (Manager Review) authority. proAdminQC must NOT sign off.
  // Gestionnaire — autorité exclusive de signature préliminaire (révision du gestionnaire).
  PRO_MANAGER = 'proManager',
}
